<template>
  <div>
    <el-drawer
      :title="`复制设备文档-${treeName}`"
      :visible.sync="drawer"
      :close-on-press-escape="false"
      :wrapperClosable="false"
      size="80%"
      :before-close="beforeClose"
      @close="closeDrawer"
    >
      <div
        style="
          width: 100%;
          flex-wrap: wrap;
          height: calc(100vh - 65px);
          box-sizing: border-box;
          padding: 10px 20px;
          overflow-y: auto;
          overflow-x: hidden;
          position: relative;
        "
        v-loading.fullscreen.lock="loading"
      >
        <div
          style="
            width: 100%;
            background-color: #fff;
            padding: 10px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            position: sticky;
            top: 0;
            right: 0;
            z-index: 99;
          "
        >
          <div style="width: calc(100%); max-height: 90px; overflow-y: auto">
            <span style="font-size: 18px; font-weight: bold; color: #72767b">
              当前选择设备：</span
            >
            <el-tag
              style="margin-left: 10px; margin-bottom: 10px; margin-top: 10px"
              v-for="(item, index) in selectionRows"
              :key="item.Id + index"
              type="success"
              >{{ item.device_name }}</el-tag
            >
          </div>
        </div>
        <el-row style="height: 40px">
          <el-input
            v-model="searchData.DocumentTypeName"
            placeholder="请输入文件类型"
            style="width: 300px; margin-bottom: 10px; margin-right: 10px"
          ></el-input>
          <el-button @click="search()" tyle="margin-bottom: 10px" type="primary"
            >查询</el-button
          >
        </el-row>
        <el-table
          style="width: 100%"
          size="mini"
          :data="data"
          border
          height="calc(100% - 260px)"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
            label="全选"
          ></el-table-column>
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            align="center"
          ></el-table-column>

          <el-table-column
            prop="device_no"
            label="设备编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="device_name"
            label="设备名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DocumentTypeName"
            label="文件类型"
            width="200px"
            align="center"
          ></el-table-column>
          <el-table-column prop="DocumentName" label="文件名称" align="center">
            <template slot-scope="scope">
              <a :href="scope.row.ServerPath" style="color: #409eff">{{
                scope.row.DocumentName
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="DocumentSize" label="文件大小" width="130px">
            <template slot-scope="scope">
              {{ setSize(scope.row['DocumentSize']) }}
            </template>
          </el-table-column>
          <el-table-column prop="CreateTime" label="上传日期" width="150px">
            <template slot-scope="scope">
              {{ moment(scope.row.CreateTime).format('YYYY-MM-DD hh:mm') }}
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination>
        </div>
        <div
          style="
            height: 40px;

            width: 100%;

            margin-top: 10px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <el-button @click="closeDrawer">取消</el-button>
          <el-button type="primary" @click="subData">确认</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import moment from 'moment'
export default {
  data() {
    return {
      moment,
      TokenCache,
      drawer: false,
      disabled: false,
      selectionRows: [],
      dataRows: [],
      treeId: '',
      ProjectId: '',
      treeName: '',
      SupplierId: '',
      loading: false,
      fileTableList: [],
      fileInfo: {},
      isUpCheckbox: false,
      DeviceNames: [],
      searchData: {
        DocumentTypeName: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
        pageSizes: [20, 40, 80, 100],
      },
      data: [],
    }
  },
  props: {},
  components: {},
  methods: {
    subData() {
      if (this.dataRows.length == 0) {
        this.$notify.warning('请选择需要复制的文档')
        return
      }

      this.$confirm(
        '选择的文档将会复制到当前选择设备下，请确认是否复制所选文档吗？',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          this.loading = true
          this.$http
            .post(
              '/Device_TypeWork/Device_TypeTemplate/SaveCopyDocumentationData',
              {
                ProjectId: this.ProjectId,
                DeviceType: this.treeId,
                SupplierId: this.SupplierId,
                DocumentIds: this.dataRows.map((item) => item.Id),
                DeviceIds: this.selectionRows.map((item) => item.Id),
              }
            )
            .then((res) => {
              this.loading = false
              if (res.Success) {
                this.$notify.success('复制操作成功')
                this.$emit('success')
                this.closeDrawer()
              } else {
                this.$notify.error(res.Msg)
              }
            })
        })
        .catch(() => {})
      console.log(this.dataRows, 'this.dataRows')
    },
    handleSelectionChange(val) {
      this.dataRows = val
    },
    search() {
      this.pagination.currentPage = 1
      this.getDataList()
    },
    handleSizeChange(size) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = size
      this.getDataList()
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page
      this.getDataList()
    },

    //字节转换
    setSize(size) {
      let data = ''
      const _size = Number.parseFloat(size)
      if (_size < 1 * 1024) {
        //如果小于0.1KB转化成B
        data = _size.toFixed(2) + 'B'
      } else if (_size < 1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        data = (_size / 1024).toFixed(2) + 'KB'
      } else if (_size < 1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        data = (_size / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        //其他转化成GB
        data = (_size / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }
      const size_str = data + ''
      const len = size_str.indexOf('.')
      const dec = size_str.substr(len + 1, 2)
      if (dec == '00') {
        //当小数点后为00时 去掉小数部分
        return size_str.substring(0, len) + size_str.substr(len + 3, 2)
      }
      return size_str
    },
    getDataList() {
      this.loading = true
      this.$http
        .post('/Device_TypeWork/Device_TypeTemplate/GetDocumentationList', {
          ProjectId: this.ProjectId,
          DeviceType: this.treeId,
          SupplierId: this.SupplierId,
          DocumentTypeName: this.searchData.DocumentTypeName,
          PageIndex: this.pagination.currentPage,
          PageRows: this.pagination.pageSize,
          // DeviceIds: this.selectionRows.map((item) => item.Id),
        })
        .then((res) => {
          if (res.Success) {
            this.loading = false
            this.data = res.Data
            this.pagination.total = res.Total || 0
          }
        })
    },
    // 打开        选中数据 设备分类ID 设备分类名称 项目ID 供应商ID
    async openDrawer(
      selectionRows,
      treeId,
      treeName,
      ProjectId,
      SupplierId,
      disabled
    ) {
      this.SupplierId = SupplierId
      this.treeId = treeId
      this.treeName = treeName
      this.ProjectId = ProjectId
      this.selectionRows = selectionRows
      this.disabled = disabled ? true : false
      this.fileInfo = {}
      this.drawer = true
      // if (disabled) {
      //   await this.getInfoData()
      // }
      this.getDataList()
    },
    beforeClose(done) {
      if (!this.disabled) {
        this.$confirm(
          '请确认是否已提交数据，关闭后未提交的数据将清空，确认关闭吗？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            done()
          })
          .catch(() => {})
      } else {
        done()
      }
    },
    closeDrawer() {
      this.drawer = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
::v-deep .el-drawer__header {
  margin-bottom: 20px;
}
::v-deep .el-upload-list {
  padding: 5px;
}
::v-deep .upload-demo {
  display: flex;
  align-items: center;
}
</style>
